import React, { useState, useEffect, useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import logo from './dkm_logo.png';
import Modal from 'react-modal';
import OrderDetail from './OrderDetail';
import '../App.css';
import { ApiGet } from '../Api';
import { GetTime } from '../Function';

function DkmMonitoring() {
  Modal.setAppElement('#root')
  
  const apiUrl = process.env.REACT_APP_API_DOMAIN + 'dkm/';
  const backgroundMainColor = 'rgb(12, 35, 64)';
  const backgroundSubColor = 'rgb(18, 46, 78)';
  const logoHeight = '60px'; //logo height + logo paddingTop
  const titleColor= 'rgb(153, 255, 153)';

  const [certification, setCertification] = useState(process.env.REACT_APP_DEV === 'true');
  const [gridStyle, setGridStyle] = useState(GetGridStyle());
  const [isMobile, setIsMobile] = useState(false);
  const [refreshTime, setRefreshTime] = useState('0001-01-01 00:00:00');
  const [barLineMixedData, setBarLineMixedData] = useState(GetBarLineMixedOption());
  const [pieData, setPieData] = useState(GetPieOption());
  const [barData, setBarData] = useState(GetBarOptoin());
  const [dailyOutput, setDailyOutput] = useState({ 'motor': 0, 'reducer': 0, 'dsy': 0 });
  const [ispopupDragging, setIsPopupDragging] = useState(false);
  const barLineMixedRef = useRef(null);
  const barRef = useRef(null);
  const pieRef = useRef(null);

  function Resize() {
    setGridStyle(GetGridStyle());
  };

  useEffect(() => {
    document.title = 'DKM MONITORING';

    if(!certification) {
      if (document.referrer !== process.env.REACT_APP_URL_DKM && document.referrer !== process.env.REACT_APP_URL_DKM + 'main' && document.referrer !== process.env.REACT_APP_URL_DKM + 'main#' && document.referrer !== process.env.REACT_APP_URL_DKM + 'main?APPTYPE=APP') {
        window.location.href = process.env.REACT_APP_URL_DKM + 'main';
      } else {
        setCertification(true);
      }
    } 

    setIsMobile(/mobile/i.test(navigator.userAgent));
    window.addEventListener('resize', Resize);

    Inquiry();

    setInterval(()=>{
      Inquiry();
    }, 1000 * 60);

    return () => {
      window.removeEventListener('resize', Resize);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("mousemove", PopupMouseMove);

    return () => {
      window.removeEventListener('mousemove', PopupMouseMove);
    };
  }, [ispopupDragging]);

  function Inquiry() {
    DrawDailyOrder();
    DrawMontlyOrder();
    DailyProduction();

    setRefreshTime(GetTime());
  }

  async function DailyProduction() {
    const response = await ApiGet(apiUrl + 'daily-production');
    if (response !== null && response.ok) {
      const json = await response.json();
      const data = json.data[0];
      setDailyOutput({ 'motor': data.motor_pp_qty, 'reducer': data.reducer_pp_qty, 'dsy': data.dsy_pp_qty });
    }
  }

  async function DrawDailyOrder() {
    const response = await ApiGet(apiUrl + 'daily-order');
    if (response !== null && response.ok) {
      const json = await response.json();
      let x = [];
      let y1 = [];
      let y2 = [];

      for (const index in json.data) {
        const data = json.data[index];
        x.push(data.order_dt);
        y1.push({ value: data.so_qty, date: data.order_dt });
        y2.push({ value: parseFloat((data.out_qty/data.so_qty*100).toFixed(2)), name: `${data.out_qty}/${data.so_qty}`, date: data.order_dt });
      }
      x = x.slice().reverse();
      y1 = y1.slice().reverse();
      y2 = y2.slice().reverse();
      setBarLineMixedData(GetBarLineMixedOption('일별 출고 물량', x, '수주', '출고/수주(%)', y1, y2)); 
    }
  }

  async function DrawMontlyOrder() {
    const response = await ApiGet(apiUrl + 'monthly-order');
    if (response !== null && response.ok) {
      const json = await response.json();
      const data = json.data[0];

      const barChartArray = [
        { value: data.order_qty_month_dsy === 0 ? 0 : parseFloat((data.out_qty_month_dsy/data.order_qty_month_dsy*100).toFixed(2)), name: `${data.out_qty_month_dsy}/${data.order_qty_month_dsy}` },
        { value: data.order_qty_month_reducer === 0 ? 0 : parseFloat((data.out_qty_month_reducer/data.order_qty_month_reducer*100).toFixed(2)), name: `${data.out_qty_month_reducer}/${data.order_qty_month_reducer}` },
        { value: data.order_qty_month_motor === 0 ? 0 : parseFloat((data.out_qty_month_motor/data.order_qty_month_motor*100).toFixed(2)), name: `${data.out_qty_month_motor}/${data.order_qty_month_motor}` },
        { value: data.total_order_qty_month === 0 ? 0 : parseFloat((data.out_qty_month/data.total_order_qty_month*100).toFixed(2)), name: `${data.out_qty_month}/${data.total_order_qty_month}` }
      ];
      setBarData(GetBarOptoin('수주 대비 출고(월별)', '출고/수주(%)', ['DSY', '감속기', '모터', '출고'], barChartArray));

      const pieChartArray = [];
      if (data.order_qty_month_motor-data.out_qty_month_motor > 0) {
        pieChartArray.push({ value: data.order_qty_month_motor-data.out_qty_month_motor, name: '모터' });
      }
      if (data.order_qty_month_reducer-data.out_qty_month_reducer > 0) {
        pieChartArray.push({ value: data.order_qty_month_reducer-data.out_qty_month_reducer, name: '감속기' });
      }
      if (data.order_qty_month_dsy-data.out_qty_month_dsy > 0) {
        pieChartArray.push({ value: data.order_qty_month_dsy-data.out_qty_month_dsy, name: 'DSY' });
      }
      setPieData(GetPieOption('수주 잔량 비율(미출고)', pieChartArray.length === 1 ? '분류' : '', pieChartArray, pieChartArray.length === 1 ? 'center' : undefined));
    }
  }

  function GetGridStyle() {
    let gridStyle = {
      display: 'grid',
      gap: '20px',
      padding: '20px',
      backgroundColor: backgroundMainColor,
      width: '100vw',
      height: `calc(100vh - ${logoHeight})`,
      boxSizing: 'border-box', //패딩을 포함하여 크기 계산
      overflow: 'auto',
      scrollbarWidth: 'none'
    };

    if (window.innerWidth > 800) {
      gridStyle.gridTemplateColumns = '2fr 1fr';
      return gridStyle;
    } else {
      gridStyle.gridTemplateColumns = 'repeat(1, 1fr)';
      return gridStyle;
    }
  };

  function Reload() {
    //재조회되는 이펙트를 보여주기 위해 조회 전 데이터 초기화    
    setBarLineMixedData(GetBarLineMixedOption());
    setBarData(GetBarOptoin());
    setPieData(GetPieOption());

    Inquiry();
  }

  function GetBarLineMixedOption(title, xAxis, yAxis1, yAxis2, yAxis1Data, yAxis2Data) {
    return {
      grid: {
        top: '25%',
        left: window.innerWidth > 800 ? '10%' : '15%',
        right: window.innerWidth > 800 ? '10%' : '15%',
        bottom: '20%'
      },
      title: {
        text: title,
        left: 'center',
        top: 20,
        textStyle: {
          color: titleColor,
          fontSize: window.innerWidth > 800 ? 30 : 25
        },
      },
      tooltip: {
        trigger: 'axis', // 축을 따라 툴팁을 표시
      },
      legend: {
        orient: 'horizontal',
        bottom: '10px',
        left: 'center',
        textStyle: {
          color: 'white',
          fontSize: 10
        },
        itemWidth: 10, //color box width
        itemHeight: 10 //color box height
      },
      xAxis: {
        type: 'category',
        data: xAxis, // X축 데이터
        axisLine: {
          lineStyle: {
            color: 'white',
          }
        },
        axisLabel: {
          //interval: 1,  //모든 데이터에 레이블을 표시
          //rotate: 45,    //레이블 각도
          //fontSize: 10,   //폰트 크기
        },
      },
      yAxis: [
        {
          type: 'value', // 첫 번째 Y축 (막대그래프용)
          name: yAxis1,
          min: 0,
          axisLine: {
            lineStyle: {
              color: 'white',
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: 'gray',
            }
          }
        },
        {
          type: 'value', // 두 번째 Y축 (꺾은선 그래프용)
          name: yAxis2,
          max: 100,
          position: 'right',
          axisLabel: {
            formatter: '{value}%',
          },
          axisLine: {
            lineStyle: {
              color: 'white',
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: 'gray',
            }
          }
        },
      ],
      series: [
        {
          name: yAxis1,
          type: 'bar', // 막대그래프
          data: yAxis1Data,
          itemStyle: {
            color: '#5470C6',
          },
          /*label: {
            show: true,
            position: 'top', 
            color: 'white',
            textBorderColor: 'black',
            textBorderWidth: 2,
            fontSize: 20,
            fontWeight: 'bold'
          },*/
        },
        {
          name: yAxis2,
          type: 'line', // 꺾은선 그래프
          yAxisIndex: 1, // 두 번째 Y축 사용
          data: yAxis2Data,
          itemStyle: {
            color: 'red',
          },
          smooth: true, // 꺾은선 그래프에 곡선 효과 추가
          label: {
            show: true,
            position: 'top',
            color: 'white',
            textBorderColor: 'black',
            textBorderWidth: 2,
            fontSize: window.innerWidth > 800 ? 20 : 10,
            formatter: '{c}%\n({b})',
            fontWeight: 'bold'
          },
        },
      ],
    };
  }

  function GetBarOptoin(title, dataName, columnName, data) {
    return {
      grid: {
        top: '20%',
        left: '15%',
        right: '15%',
        bottom: '10%'
      },
      title: {
        text: title,
        left: 'center',
        top: 20,
        textStyle: {
          color: titleColor,
          fontSize: window.innerWidth > 800 ? 30 : 25
        },
      },
      tooltip: {
        trigger: 'item',
      },
      xAxis: {
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: {
            color: 'white',
          }
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false
        },
      },
      yAxis: {
        type: 'category',
        data: columnName,
        axisLine: {
          lineStyle: {
            color: 'white',
          }
        },
      },
      series: [
        {
          name: dataName,
          type: 'bar',
          data: data,
          itemStyle: {
            color: '#5470C6', // 막대 색상 설정
          },
          label: {
            show: true,
            position: 'right', // 레이블을 막대의 윗부분에 표시
            color: 'white',
            textBorderColor: 'black',
            textBorderWidth: 2,
            fontSize: window.innerWidth > 800 ? 20 : 10,
            formatter: '{c}%\n({b})',
            fontWeight: 'bold'
          },
        },
      ],
    };
  }

  function GetPieOption(title, dataName, data, position = 'inside') { 
    return {
      grid: {
        top: '50%',
        left: '10%',
        right: '10%',
        bottom: '5%'
      },
      title: {
        text: title,
        left: 'center',
        top: 20,
        textStyle: {
          color: titleColor,
          fontSize: window.innerWidth > 800 ? 30 : 25
        },
      },
      tooltip: {
        trigger: 'item',
        //formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'horizontal',
        bottom: '10px',
        left: 'center',
        textStyle: {
          color: 'white',
          fontSize: 10
        },
        itemWidth: 10, //color box width
        itemHeight: 10 //color box height
      },
      //color: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd'], //색 배열 설정
      series: [
        {
          name: dataName,
          type: 'pie',
          radius: window.innerWidth > 800 ? '70%' : '60%',
          center: ['50%', '52%'], // X축, Y축 수정
          data: data,
          label: {
            color: 'white',
            fontSize: window.innerWidth > 800 ? 20 : 15,
            textBorderColor: 'black',  // 텍스트 테두리 색상 설정
            textBorderWidth: 2,  // 텍스트 테두리 두께 설정
            fontWeight: 'bold',
            show: true,  //항상 레이블을 표시
            position: position, //outside로 하면 바깥쪽
            formatter: '{b}'//'{c}' //{b} : {c} b는 name, c는 value
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
  }

  function ChangeFullscreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      return;
    }

    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { //Firefox
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { //Chrome, Safari, Opera
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { //IE/Edge
      elem.msRequestFullscreen();
    }
  }

  const eChartsStyle = { width: '100%', height: '100%' };
  const buttonStyle = { backgroundColor: backgroundMainColor, color: 'rgb(204,204,204)', border: 'none', fontSize: 30 };
  const gridItemStyle = {
    backgroundColor: backgroundSubColor,
    borderRadius: '10px',
    height: `calc((100vh - 60px - ${logoHeight}) / 2)`, // 행 수에 맞게 높이를 계산, 2행이니 세로 간격의 총합 = padding 20px * 2 + gap 20px = 60px,
  };

  function PopupMouseMove(event) {
    if (ispopupDragging && event.buttons === 1) {
      setPopupStyle((previousState) => {
        const previousStyle = {...previousState};

        //팝업창이 화면 밖으로 나가지 않을 때까지만 이동
        if (previousStyle.content.top + event.movementY - popupStyle.content.height/2 > 0 && 
          previousStyle.content.left + event.movementX - popupStyle.content.width/2 > 0 && 
          previousStyle.content.top + event.movementY + popupStyle.content.height/2 < window.innerHeight && 
          previousStyle.content.left + event.movementX + popupStyle.content.width/2 < window.innerWidth) {
          
          previousStyle.content.left = previousStyle.content.left + event.movementX;
          previousStyle.content.top = previousStyle.content.top + event.movementY;
        }

        return previousStyle;
      });
     }
  }

  function HideToolTip(instance) {
    //팝업 열기 전에 Tool Tip 제거(터치로 팝업 열 때 제거되지 않아 팝업 위로 보이는 문제 방지)
    instance.dispatchAction({
      type: 'hideTip'
    });
  }

  function OnChartReady(instance) {
    instance.on('click', (params) => OnClickChart(params.data.date));
  }

  function OnClickChart(date) {
    setPopupStyle((previousState) => {
      const previousStyle = {...previousState};

      previousStyle.content.width = '99vw';  
      previousStyle.content.height = '99vh';  

      previousStyle.content.top = window.innerHeight / 2;
      previousStyle.content.left = window.innerWidth / 2;
      previousStyle.content.transform = 'translate(-50%, -50%)';

      return previousStyle;
    });

    HideToolTip(barLineMixedRef.current.getEchartsInstance());
    HideToolTip(pieRef.current.getEchartsInstance());
    HideToolTip(barRef.current.getEchartsInstance());

    setPopupContent(<OrderDetail orderDate={typeof date !== 'object' ? date : undefined}/>);
    setPopupName(`출고 현황`);
    setIsPopupOpen(true);
  }

  //popup drag
  function PopupTopBarMouseDown(event) {
    setIsPopupDragging(true);
  }
  function PopupMouseUp() {
    setIsPopupDragging(false);
  }
  //팝업창
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(<div></div>);
  const [popupName, setPopupName] = useState('');
  const [popupStyle, setPopupStyle] = useState({
    overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    content: {
    width: '100vw',
    height: '100vh',
    borderRadius: '5px',
    padding: '0',
    backgroundColor: '#F8F8F8',
    transform: 'translate(-50%, -50%)',
    top: window.innerHeight / 2,
    left: window.innerWidth / 2,
    overflow: 'auto'
    }
  });
  const popupModal = (
    <div onMouseUp={PopupMouseUp}>
      <Modal isOpen={isPopupOpen} style={popupStyle} onAfterOpen={OnAfterOpenPopup} /*onRequestClose={OnRequestClosePopup} /*modal 밖 클릭했을 때 나가짐*/>
        <div onMouseDown={PopupTopBarMouseDown} style={{ width: '100%', backgroundColor: 'rgb(18, 46, 78)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'move', userSelect: 'none' }}>
          <span style={{ color: 'white', margin: '10px' }}>{popupName}</span>
          <button style={{ width: '25px', margin: '10px', padding: '0px' }} onClick={OnRequestClosePopup}>✕</button>
        </div>

        {popupContent}
      </Modal>
    </div>
   );
   function OnAfterOpenPopup() {

   }
   function OnRequestClosePopup() {
    setIsPopupOpen(false);
    setPopupContent(<div></div>);
   }

  return (
    <div>
      {certification && <div onContextMenu={(event)=>{event.preventDefault();}}>
        <div style={{ backgroundColor: backgroundMainColor, paddingTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', userSelect: 'none' }}>
          <img src={logo} width={'121.85px'} height={'40px'} style={{ marginLeft: '20px' }}/>

          <div style={{ marginRight: '1vw' }}>
            <button title={refreshTime} onClick={Reload} style={buttonStyle}>⟳</button>
            {!isMobile && <button title={document.fullscreenElement ? '최소화' : '최대화'} onClick={ChangeFullscreen} style={buttonStyle}>◱</button>}
          </div>
        </div>

        <div style={gridStyle}>
          <div style={gridItemStyle} onClick={OnClickChart}>
            <ReactECharts ref={barLineMixedRef} option={barLineMixedData} style={eChartsStyle} onChartReady={OnChartReady}/>
          </div>

          <div style={gridItemStyle}>
            <ReactECharts ref={pieRef} option={pieData} style={eChartsStyle}/>
          </div>

          <div style={gridItemStyle}>
            <ReactECharts ref={barRef} option={barData} style={eChartsStyle}/>
          </div>

          <div style={gridItemStyle}>
            <div style={{ paddingBottom:15, height: `calc((100vh - 60px - ${logoHeight}) / 2 - 15px)`, fontFamily: 'Arial, sans-serif', userSelect: 'none', display: 'grid', placeItems: 'center', color: 'white', fontSize: window.innerWidth > 800 ? 35 : 30, textAlign: 'center' }}>
              <div style={{ fontWeight: 'bold', color: titleColor }}>당일 누적 생산량</div>

              <div style={{ whiteSpace:'normal' }}>
                모터 {dailyOutput.motor}대
              </div>
              <div style={{ whiteSpace:'normal'}}>
                감속기 {dailyOutput.reducer}대
              </div>
              <div style={{ whiteSpace:'normal' }}>
                DSY {dailyOutput.dsy}대
              </div>
            </div>
          </div>
        </div>

        {popupModal}
      </div>}
    </div>
  );
}

export default DkmMonitoring;